import type { AccreditationVersion, JurisdictionWithPublishedState } from '../_types/awb';
import { AWB } from '../_types/awb';

function isVersionEverPublished(version: AccreditationVersion): boolean {
  return (
    version.publishedState === 'PUBLISHED' ||
    Boolean(version.firstPublishedAt) ||
    Boolean(version.lastPublishedAt)
  );
}

export function canDeleteLexipolComplianceItems(version: AccreditationVersion | undefined): boolean {
  if (!version) return false;

  return !isVersionEverPublished(version);
}

export function isStandard(node: AWB.Node): node is AWB.Standard {
  return 'subStandards' in node;
}

export function isSubStandard(node: AWB.Node): node is AWB.SubStandard {
  return 'requirements' in node;
}

export function isRequirement(node: AWB.Node): node is AWB.Requirement {
  return !isStandard(node) && !isSubStandard(node);
}
